export interface PartnerId {
    partnerId: number;
}

export interface AgentCompanyDashboardGeneralSummary {
    averageSales: number;
    bookings: number;
    guests: number;
    sales: number;
}

export interface AgentCompanyDashboardTourSalesByProduct {
    averageSales: number;
    bookingCount: number;
    bookingWindow: number;
    totalCustomer: number;
    totalSalesDollar: number;
    tourName: string;
}

export interface AgentCompanyDashboardBookingStats {
    avgBookingWindow: string;
    bestGrossingTourName: string;
    bestGrossingTourTotal: number;
    bestSellingCruiseLine: string;
    bestSellingCruiseLineTotal: number;
    bestSellingCruiseShip: string;
    bestSellingCruiseShipTotal: number;
    mostPassengersBookedTotal: number;
    mostPassengersBookedTourName: string;
    secondBestSellingCruiseLine: string;
    secondBestSellingCruiseLineTotal: number;
    secondBestSellingCruiseShip: string;
    secondBestSellingCruiseShipTotal: number;
    thirdBestSellingCruiseLine: string;
    thirdBestSellingCruiseLineTotal: number;
    thirdBestSellingCruiseShip: string;
    thirdBestSellingCruiseShipTotal: number;
}

export interface AgentCompanyDashboardSalesByDay {
    bookingAmount: number;
    bookingCount: number;
    bookingPassengerCount: number;
    dayName: string;
    dayNumber: number;
}

export interface AgentCompanyDashboardSalesByMonth {
    bookingAmount: number;
    bookingCount: number;
    bookingPassengerCount: number;
    monthName: string;
    monthNumber: number;
    reportYear: number;
}

export interface Agent {
    partnerId: number;
    partnerName: string;
    uniqueName: string;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    phoneNumber: string;
    companyUniqueId: string;
    email: string;
    address1: string;
    address2: string;
    city: string;
    stateId: number;
    countryId: number;
    zipCode: string;
    notes: string;
    isActive: boolean;
    type: number;
    commission: number;
    allowInvoice: boolean;
    website: string;
    isParentCompany: boolean;
    isCruiseLine: boolean;
    shipCompanyId: number;
}

export interface AgentUser {
    userId: string;
    userName: string;
    userEmail: string;
    userRole: string | null;
    checklevel: string | null;
    formstatus: number;
    userRoleId: number | null;
    agentId: number | null;
    userPassword: string | null;
    emailConfirmed: false;
    passwordHash: string;
    securityStamp: string;
    phoneNumber: string;
    phone: string;
    phoneNumberConfirmed: boolean | null;
    twoFactorEnabled: boolean;
    lockoutEndDateUtc: string | null;
    lockoutEnabled: boolean;
    accessFailedCount: number;
    firstName: string;
    lastName: string;
    companyUniqueID: string;
    isActive: boolean;
    modifiedBy: string | null;
    createdBy: string | null;
    modifiedDate: string | null;
    createdDate: string | null;
    roleId: number | null;
    rolesId: number | null;
    locationid: number;
    departmentid: number;
    positionid: number;
    payRateid: number | null;
    arrivalDateid: number | null;
    qualificationsid: number;
    trainingid: number;
    evaluationsid: number;
    specialLicensesid: number | null;
    coachingid: number | null;
    address: string;
    nickName: string | null;
    address2: string;
    city: string;
    countryName: string;
    stateName: string;
    countryId: number | null;
    stateId: number | null;
    zipCode: string;
    allowUserInvoice: boolean;
    websiteURL: string | null;
    profilePicturePath: string | null;
    profilePictureUploadedFileName: string | null;
    isEmployee: boolean;
    year: string | null;
    housingLocation: string | null;
    housingLocationID: number | null;
    weeklyrent: number | null;
    moveindate: number | null;
    effectivedate: null;
    notes: string | null;
    hrYear: string | null;
    hrYearid: number;
    housingYear: string | null;
    idLocation: number | null;
    locationIds: number | null;
    idDepartment: number | null;
    departmentIds: number | null;
    idPosition: number | null;
    positionIds: number | null;
    idqualification: number | null;
    idTraing: number | null;
    idEvaluation: number | null;
    multiLocationid: number | null;
    multiDepartmentid: number | null;
    multiPositionId: number | null;
    multiQualificationsid: number | null;
    multiTrainingid: number | null;
    multiEvaluationsid: number | null;
    payRateids: number | null;
    locationname: string | null;
    departmentname: string | null;
    positionname: string | null;
    qualificationnames: string | null;
    evaluationsidsname: string | null;
    trainingidsname: string | null;
}

export interface UserAgentMapping {
    id: number | null;
    userId: number | null;
    agentId: number | null;
}

export function agentUsertoAgent(agentUser: AgentUser): Agent {
    return {
        partnerId: 0,
        partnerName: '',
        uniqueName: agentUser.userName,
        contactPersonFirstName: agentUser.firstName,
        contactPersonLastName: agentUser.lastName,
        phoneNumber: agentUser.phoneNumber,
        companyUniqueId: agentUser.companyUniqueID,
        email: agentUser.userEmail,
        address1: agentUser.address,
        address2: agentUser.address2,
        city: agentUser.city,
        stateId: agentUser.stateId || 0,
        countryId: agentUser.countryId || 0,
        zipCode: agentUser.zipCode,
        notes: agentUser.notes || '',
        isActive: agentUser.isActive || true,
        type: 0,
        commission: 0,
        allowInvoice: agentUser.allowUserInvoice,
        website: agentUser.websiteURL || '',
        isParentCompany: true,
        isCruiseLine: true,
        shipCompanyId: 0,
    };
}
